<template>
	<div class="inner-page attached-users">
		<AppHead title="Attached Users" />

		<PageHeader 
			title="Attached Users"
			:desc="thisUser.id != $page.props.user.id ? `See which users are attached to this user.` : `See which users are attached to you.`"
			:hasButton="false"
			:showHelper="true"
			helpTitle="Attached Users"
			helpDesc="Any users which are attached to this user will be shown below. These users were invited by this user and are therefore attached to them. If any attached users create a case, this user will receieve a notification."
			:hr="true"
			/>

		<template v-if="thisUser.id != $page.props.user.id">
			<Subtitle 
				title="The User"
				/>
			<div class="user-info">
				<div class="user-info-item">
					<div class="label">Name</div>
					<div class="value">{{ thisUser.name }}</div>
				</div>
				<div class="user-info-item">
					<div class="label">Email</div>
					<div class="value">{{ thisUser.email }}</div>
				</div>
				<div class="user-info-item">
					<div class="label">Phone</div>
					<div class="value">{{ thisUser.phone }}</div>
				</div>
				<div class="user-info-item">
					<div class="label">User type</div>
					<div class="value">{{ niceRoleName(thisUser.user_type) }}</div>
				</div>
				<div class="user-info-item">
					<div class="label">Distributor</div>
					<div class="value">
						{{ thisUser.teams && thisUser.teams.length > 0 ? thisUser.teams[0].name : 'N/A' }}
					</div>
				</div>
			</div>
		</template>

		<Subtitle 
			:title="thisUser.id != $page.props.user.id ? `Users attached to ${thisUser.name}` : 'Users attached to you'"
			/>

		<template v-if="attachedUsers && attachedUsers.length > 0">
			<div class="headers">
				<div class="row">
					<span>Name</span>
					<span>Email</span>
					<span>User type</span>
					<span>Distributor</span>
					<span>Invited when</span>
					<span>Cases created</span>
				</div>
			</div>
			<ul>
				<li v-for="user in attachedUsers" :key="user.id">
					<span>
						{{ user.name }}
					</span>
					<span>
						{{ user.email }}
					</span>
					<span>
						{{ niceRoleName(user.user_type) }}
					</span>
					<span>
						{{ user.teams && user.teams.length > 0 ? user.teams[0].name : 'N/A'  }}
					</span>
					<span>
						{{ niceDate(user.created_at) }}
					</span>
					<span>
						{{ user.projects_count }}
					</span>
				</li>
			</ul>
		</template>

		<Placeholder 
			v-else
			message="There are no users attached to this user."
			/>


		<template v-if="thisUser.id == $page.props.user.id && thisUser.user_type == 'team_admin'">
			
			<Subtitle 
				title="Users in this Distributor team"
				/>

			<template v-if="teamUsers && teamUsers.length > 0">
				<div class="headers">
					<div class="row">
						<span>Name</span>
						<span>Email</span>
						<span>User type</span>
						<span>Distributor</span>
						<span>Invited when</span>
						<span>Cases created</span>
					</div>
				</div>
				<ul>
					<li v-for="user in teamUsers" :key="user.id">
						<span>
							{{ user.name }}
						</span>
						<span>
							{{ user.email }}
						</span>
						<span>
							{{ niceRoleName(user.user_type) }}
						</span>
						<span>
							{{ user.teams && user.teams.length > 0 ? user.teams[0].name : 'N/A'  }}
						</span>
						<span>
							{{ niceDate(user.created_at) }}
						</span>
						<span>
							{{ user.projects_count }}
						</span>
					</li>
				</ul>
			</template>

			<Placeholder 
				v-else
				message="There are no users in this team."
				/>
		</template>

		
	</div>
</template>

<script>

import moment from 'moment'

import AppHead from "@/Components/AppHead"
import AppLayout from "@/Layouts/AppLayout.vue"
import PageHeader from "@/Components/PageHeader"
import Subtitle from "@/Components/Subtitle"
import Placeholder from "@/Components/Placeholder"

export default {
	layout: AppLayout,
	components: {
		AppHead,
		AppLayout,
		PageHeader,
		Subtitle,
		Placeholder
	},
	props: {
		thisUser: {
			type: Object,
			required: true
		},
		teamUsers: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			
		};
	},
	computed: {
		attachedUsers() {
			return this.thisUser.attached_users
		}
	},
	methods: {
		niceRoleName(type){
			switch(type){
				case 'admin':
					return 'Meshworks Admin'
					break
				case 'global_viewer':
					return 'Meshworks Viewer'
					break
				case 'team_admin':
					return 'Distributor Admin'
					break
				case 'team_user':
					return 'Distributor User'
					break
				case 'viewer':
					return 'Viewer'
					break
				case 'user':
					return 'User'
					break
			}
		},
		niceDate(dateString){
      let theDate = new Date(dateString)
      return moment(theDate).format('DD/MM/YYYY')
    },
	},
	mounted() {
		// console.log(this.thisUser)
	}
};
</script>

<style lang="sass">

.attached-users
	.user-info
		padding: 15px
		border-radius: 8px
		box-shadow: 0 0 10px rgba(0,0,0,0.1)
		background-color: #fff
		display: grid
		grid-template-columns: repeat(auto-fit, minmax(min(100%, 200px), 1fr))
		gap: 10px
		position: relative
		margin-bottom: 50px

		.user-info-item
			.label
				font-family: 'Roboto Condensed', sans-serif
				font-weight: 700
				font-size: 16px
				line-height: 1.1
				color: #252525
				margin-bottom: 10px

			.value
				font-size: 14px
				font-weight: 400
				
						
	ul
		list-style: none
		padding: 0
		width: 100%
		background-color: #fff
		border-radius: 8px
		box-shadow: 0 1px 3px rgba(#000, 0.12)
		padding: 0 20px
		margin-bottom: 50px

		li
			font-size: 14px
			font-weight: 400
			font-family: 'Roboto', sans-serif
			color: #252525
			line-height: 1.1
			height: 60px
			border-bottom: 1px solid #d0d0d0
			align-items: center
			display: grid
			grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr
			
			&:last-child
				border-bottom: none

	.headers
		font-size: 18px
		font-weight: 700
		font-family: 'Roboto Condensed', sans-serif
		color: #252525
		line-height: 1.1
		margin-bottom: 10px

		.row
			padding: 0 20px
			display: grid
			grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr
				

</style>